import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../shared/services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OPCConstant } from '../opc.const';
import { PartCategory } from './partcategory.model';
import { ProductLineDetails } from '../productline/productlinedetails/productlinedetails.model';
import { ProductLine } from '../productline/productline.model';
import { PartCategoryService } from '../../shared/services/partcategory.service';
import { OPCSettings } from '../../shared/models/opcsettings.model';

@Component({
  selector: 'app-partcategory',
  templateUrl: 'partcategory.component.html',
  styleUrls: ['partcategory.component.css']
})

export class PartCategoryComponent implements OnInit {
  productFamilyID: number;
  defaultImage: string;
  productLineID: number;
  partCategories: PartCategory[];
  productLineDetails: ProductLineDetails;
  selectedProductLine: ProductLine;
  bypass: boolean;
  activeItem: string;
  partCategoryImgPath: string;
  productLineImgPath: string;
  opcSettings: OPCSettings = new OPCSettings();

  constructor(private _partCategoryService: PartCategoryService
    , private _productService: ProductService, private _route: ActivatedRoute, private _router: Router) {
    this.bypass = false;
  }

  getPartCategory() {
    this._partCategoryService.getPartCategoryById(this.productLineID).subscribe(res => {
      this.partCategories = res;
    });
  }

  getProductLines() {
      this._productService.getProductLineById(this.productFamilyID).subscribe(res => {
        this.productLineDetails = res;
        if (this.productLineDetails.productFamilyName === OPCConstant.BYPASS_FAMILY) {
          this.bypass = true;
        }
        this.selectedProductLine = this.productLineDetails.productLines.find(pl => pl.productLineID === this.productLineID);
        if (this.bypass) {
          this.activeItem = this.productLineDetails.productFamilyName;
        } else {
          this.activeItem = this.selectedProductLine.code + ' ' + this.selectedProductLine.vintageStart.substr(0, 4) + ' - ' +
            (this.selectedProductLine.vintageEnd ? this.selectedProductLine.vintageEnd.substr(0, 4) : 'PRESENT');
        }
      });
  }
  dropdownChange(event) {
    const selectedDropdown = event.target.value;
    this._router.navigateByUrl('/productfamily/' + this.productFamilyID + '/productline/' + selectedDropdown);
    const pl = this.productLineDetails.productLines.find(p => p.productLineID === selectedDropdown);
    this.activeItem = pl.code + ' ' + pl.vintageStart.substr(0, 4) + ' - ' + (pl.vintageEnd ? pl.vintageEnd.substr(0, 4) : 'PRESENT');
  }
  errorImage(event) {
    //event.target.src = this.defaultImage;
  }
  ngOnInit() {
    this._route.params.subscribe(param => {
      this.productFamilyID = +param['pfid'];
      this.productLineID = +param['plid'];
      this.getProductLines();
      this.getPartCategory();
    });

  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/partcategory/partcategory.component.ts